export default "__VITE_ASSET__B99fcvXI__"